import React, { useContext, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import Header from "../Pages/Administration/Layout/Header";
import Sidebar from "../Pages/Administration/Layout/Sidebar";
import Loader from "../Component/Loader";

const AdminAuthProtected = () => {
  const { adminToken, loading } = useContext(MyContext);

  // Add external CSS resources
  useEffect(() => {
    document.body.classList.add("admin-app");

    // Poppins for all administration pages
    const poppinsFont = document.createElement("link");
    poppinsFont.href =
      "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap";
    poppinsFont.rel = "stylesheet";
    document.head.appendChild(poppinsFont);

    // Add vendor CSS files
    const vendorStyles = [
      "font-awesome.css",
      "icofont.css",
      "themify.css",
      "flag-icon.css",
      "feather-icon.css",
      "slick.css",
      "slick-theme.css",
      "scrollbar.css",
      "animate.css",
      "echart.css",
      "date-picker.css",
      "bootstrap.css",
    ];

    vendorStyles.forEach((style) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.type = "text/css";
      link.href = `https://admin.pixelstrap.net/riho/assets/css/vendors/${style}`;
      document.head.appendChild(link);
    });

    // Add main app styles
    const appStyles = ["style.css", "responsive.css"];

    appStyles.forEach((style) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.type = "text/css";
      link.href = `https://admin.pixelstrap.net/riho/assets/css/${style}`;
      document.head.appendChild(link);
    });

    // Add color theme
    const colorTheme = document.createElement("link");
    colorTheme.id = "color";
    colorTheme.rel = "stylesheet";
    colorTheme.href =
      "https://admin.pixelstrap.net/riho/assets/css/color-1.css";
    colorTheme.media = "screen";
    document.head.appendChild(colorTheme);

    // Cleanup function to remove added styles when component unmounts
    return () => {
      document.body.classList.remove("admin-app");
      const links = document.querySelectorAll('link[href*="pixelstrap"]');
      links.forEach((link) => link.remove());
      poppinsFont.remove();
    };
  }, []);

  useEffect(() => {
    const { pathname } = window.location;

    if (pathname.includes("administration")) {
      // Add local CSS files for admin section
      const localStyles = [
        "../assets/css-2/style.css",
        "../assets/css-2/vendor/bootstrap.min.css",
        "../assets/css-2/plugins/glightbox.min.css",
        "../assets/css-2/plugins/swiper-bundle.min.css",
      ];

      localStyles.forEach((style) => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = style;
        document.head.appendChild(link);
      });

      // Cleanup function
      return () => {
        const links = document.querySelectorAll('link[href*="assets"]');
        links.forEach((link) => link.remove());
      };
    }
  }, [window.location]);

  if (!adminToken) {
    return <Navigate to="/administration" replace />;
  }

  console.log(adminToken, "adminToken");
  if (loading) {
    return <Loader />;
  }
  // Render child routes here using Outlet
  return (
    <div className="admin-shell page-wrapper compact-wrapper" id="pageWrapper">
      <Header />
      <div className="admin-shell__body page-body-wrapper">
        <Sidebar />
        <div className="admin-shell__content page-body">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const AccessRoute = ({ component: Component }) => {
  // Render the passed component as a JSX element
  return <>{Component}</>;
};

export { AdminAuthProtected, AccessRoute };
